<div class="c-page-faq">
    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
            <div class="col-md-8">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a><span>{{'FaqPortal.home'| translate}}</span></a>-</li>
                        <li class="breadcrumb-item active" aria-current="page">{{ 'FaqPortal.location' | translate}}</li>
                    </ol>
                </nav>
                <h2 class="o-title"> {{ 'FaqPortal.title' | translate}}</h2>

            </div>
        </div>




        <div *ngIf="getlang()==='en'">
            <div class="col-md-12 u-pt50">
                <div *ngFor="let faq of faqs">
                    <div class="c-accordeon">
                        <h3 class="c-accordeon__title">{{faq.sectionEn}}</h3>
                        <mat-accordion>
                            <div class="c-accordeon__item" *ngFor="let question of faq.questions">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <h4> <b> {{question.questionEn}} </b></h4>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <p>{{question.answerEn}} </p>
                                </mat-expansion-panel>
                            </div>
                        </mat-accordion>
                    </div>
                </div>
            </div>

        </div>


        <div *ngIf="getlang()==='es'">
            <div class="col-md-12 u-pt50">
                <div *ngFor="let faq of faqs">
                    <div class="c-accordeon">
                        <h3 class="c-accordeon__title">{{faq.sectionEs}}</h3>
                        <mat-accordion>
                            <div class="c-accordeon__item" *ngFor="let question of faq.questions">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <h4> <b> {{question.questionEs}} </b></h4>
                                        </mat-panel-title>

                                    </mat-expansion-panel-header>
                                    <p>{{question.answerEs}} </p>
                                </mat-expansion-panel>
                            </div>
                        </mat-accordion>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>